/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { WorkloadForm, WorkloadForm$inboundSchema } from "./workloadform.js";

/**
 * The forms for trusting a platform the catalog does not list and allowing its workloads.
 */
export type WorkloadCustomFlows = {
  /**
   * A custom flow's form, held to the management API form it submits.
   */
  allowAccess: WorkloadForm;
  /**
   * A custom flow's form, held to the management API form it submits.
   */
  editAccess: WorkloadForm;
  /**
   * A custom flow's form, held to the management API form it submits.
   */
  editPlatform: WorkloadForm;
  /**
   * A custom flow's form, held to the management API form it submits.
   */
  registerPlatform: WorkloadForm;
};

/** @internal */
export const WorkloadCustomFlows$inboundSchema: z.ZodMiniType<
  WorkloadCustomFlows,
  unknown
> = z.pipe(
  z.object({
    allow_access: WorkloadForm$inboundSchema,
    edit_access: WorkloadForm$inboundSchema,
    edit_platform: WorkloadForm$inboundSchema,
    register_platform: WorkloadForm$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "allow_access": "allowAccess",
      "edit_access": "editAccess",
      "edit_platform": "editPlatform",
      "register_platform": "registerPlatform",
    });
  }),
);

export function workloadCustomFlowsFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadCustomFlows, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadCustomFlows$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadCustomFlows' from JSON`,
  );
}
